<div class="banner-main-container">
  @if (banners.length) {

  <div class="carousel-container">
    <swiper-container
      pagination="true"
      pagination-clickable="true"
      navigation="false"
      space-between="1"
      centered-slides="true"
      autoplay-delay="2400"
      autoplay-disable-on-interaction="true"
      [style]="customStyle"
    >
      @for (item of banners; track trackByBanner) {
      <swiper-slide>
        <a [href]="item.url" target="_blank">
          <div class="as-pointer cont" [lazyLoad]="item.route"></div>
        </a>
      </swiper-slide>
      }
    </swiper-container>
  </div>
  } @else {
  <div class="carousel-container">
    <div class="as-banner-skeleton as-skeleton-animation"></div>
  </div>
  }
</div>
